var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plaintext-inner-wrap centered-wrap"},_vm._l((_vm.data),function(obj,key,idx){return (obj.txt)?_c(obj.color === 'grad' ? 'GradTextFragment' : 'TextFragment',{key:idx,tag:"component",attrs:{"tag":key === 'title' ? 'h3' : 'p',"data":obj,"wrap-width":_vm.w}}):_vm._e()}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027607b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/content/PlainText.vue
// module id = null
// module chunks = 